@use "src/sedestral/sass/mixins/texts";

.componentOfferPrice {
  display: flex;
  margin-left: auto;
  justify-content: flex-end;
  align-items: center;

  .names {
    margin-right: 30px;

    .title {
      font-size: 14px;

      @include texts.font("semi-bold");
    }

    .pricing {
      @include texts.font("bold");

      .price {
        font-size: 28px;
      }

      .period {
        font-size: 16px;
      }
    }
  }

  .button {
    background: var(--black);
    padding: 14px 20px;
    height: fit-content;
    color: var(--white);
    cursor: pointer;
    position: relative;
    border-radius: 50px;

    @include texts.font("semi-bold");

    &:hover {
      opacity: 0.7;
    }

    &.loading {
      color: transparent;
    }
  }

  @media screen and (max-width: 480px) {
    justify-content: unset;

    .names {
      margin-right: 10px;
    }

    .button {
      padding: 14px 12px;
      font-size: 14px;
      margin-left: auto;
    }
  }
}